import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {ThemeModeProvider} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import {SupportSessionBanner} from '../../app/modules/auth/components/SupportSessionBanner'
import {DemoBanner} from '../../app/modules/demo/DemoBanner'
import {AccessRestrictedNotice} from '../../app/modules/auth/components/AccessRestrictedNotice'
import {MobileDeferredBanner} from '../../app/modules/auth/components/MobileDeferredBanner'
import {AppBackdrop} from '../../app/theme/AppBackdrop'
import {useScrollState} from '../../app/theme/useScrollState'
import {TermsAcceptanceGate} from '../../app/modules/terms'
import {PrintPageIntroGate} from '../../app/modules/apps/invoice-management/invoice-print/intro/PrintPageIntroGate'
import {ProformaIntroGate} from '../../app/modules/whats-new/ProformaIntroGate'
import {BuyerLinksIntroGate} from '../../app/modules/whats-new/BuyerLinksIntroGate'
import {
  InvoiceAlertsIntroGate,
  PeriodicReportsIntroGate,
  TaxWorkspaceAlertsIntroGate,
} from '../../app/modules/whats-new/BusinessServicesIntroGates'
import {TaxPublicQrIntroGate} from '../../app/modules/whats-new/TaxPublicQrIntroGate'
import {InstallAppGate} from '../../app/modules/install-app'
import {WebPushSync} from '../../app/modules/notifications/components/WebPushSync'
import {MobileBottomNav} from '../../app/modules/apps/shared/mobile-nav/MobileBottomNav'
import {ToastHost} from '../../app/modules/apps/shared/toast/ToastHost'
import {WalletReturnHost} from '../../app/modules/online-payment/wallet/WalletReturnHost'
import {ScreenCaptureDock} from '../../app/modules/apps/ticket-management/screen-share/ScreenCaptureDock'
import {BusinessQuickSwitcher} from '../../app/modules/apps/shared/business-switcher/BusinessQuickSwitcher'
import {BusinessTabNotices} from '../../app/modules/apps/shared/business-switcher/BusinessTabNotices'

const layout = (
  <PageDataProvider>
    <ThemeModeProvider>
      <AppBackdrop />
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <DemoBanner />
              <SupportSessionBanner />
              <AccessRestrictedNotice />
              {/* The hours given during an SMS outage: until when the mobile must be registered. */}
              <MobileDeferredBanner />
              {/* The tab's own business: Ctrl+K to choose another, its name in the tab title, other tabs' notes. */}
              <BusinessQuickSwitcher />
              <BusinessTabNotices />
              {/* «افزایش موجودی و ادامه»: the payment's result on the page of the step, which then goes on. */}
              <WalletReturnHost />
              <div className='d-flex flex-column flex-column-fluid'>
                <ToolbarWrapper />
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>

      <ScrollTop />
      <MobileBottomNav />
      <ToastHost />
      {/* «نمایش صفحه‌ی من به پشتیبانی» and «ضبط صفحه»: both go on, with their «توقف», on every page. */}
      <ScreenCaptureDock />
      <TermsAcceptanceGate />
      <PrintPageIntroGate />
      {/* Opened only from «امکانات تازه»: no window at sign-in. */}
      <ProformaIntroGate />
      <BuyerLinksIntroGate />
      <InvoiceAlertsIntroGate />
      <PeriodicReportsIntroGate />
      <TaxWorkspaceAlertsIntroGate />
      <TaxPublicQrIntroGate />
      <InstallAppGate />
      <WebPushSync />
    </ThemeModeProvider>
  </PageDataProvider>
)

const MasterLayout = () => {
  const location = useLocation()
  useScrollState()
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return layout
}

export {MasterLayout}
